/* tslint:disable */
/* eslint-disable */
/**
 * 【モニタリング】コミュニケーション機能 業務AP
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 有効フラグ:enum
 * @export
 * @enum {string}
 */

export const DomEnableFlag = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;

export type DomEnableFlag = typeof DomEnableFlag[keyof typeof DomEnableFlag];


/**
 * 組織種別:enum
 * @export
 * @enum {string}
 */

export const DomOrganizationType = {
    Primary: 'primary',
    Secondary: 'secondary',
    Admin: 'admin',
    Crew: 'crew'
} as const;

export type DomOrganizationType = typeof DomOrganizationType[keyof typeof DomOrganizationType];


/**
 * 会議室状態:enum
 * @export
 * @enum {string}
 */

export const DomRoomState = {
    Empty: 'empty',
    Idle: 'idle',
    Waiting: 'waiting',
    Preparing: 'preparing',
    Active: 'active',
    Finishing: 'finishing'
} as const;

export type DomRoomState = typeof DomRoomState[keyof typeof DomRoomState];


/**
 * ChimeSDK meeting Attendee
 * @export
 * @interface EntityAttendee
 */
export interface EntityAttendee {
    /**
     * 
     * @type {string}
     * @memberof EntityAttendee
     */
    'ExternalUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityAttendee
     */
    'AttendeeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityAttendee
     */
    'JoinToken'?: string | null;
    /**
     * 
     * @type {EntityAttendeeCapabilities}
     * @memberof EntityAttendee
     */
    'Capabilities'?: EntityAttendeeCapabilities | null;
}
/**
 * 
 * @export
 * @interface EntityAttendeeCapabilities
 */
export interface EntityAttendeeCapabilities {
    /**
     * 
     * @type {string}
     * @memberof EntityAttendeeCapabilities
     */
    'Audio'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityAttendeeCapabilities
     */
    'Video'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityAttendeeCapabilities
     */
    'Content'?: string | null;
}
/**
 * 二次用会議参加者の表示名
 * @export
 * @interface EntityAttendeeLabel
 */
export interface EntityAttendeeLabel {
    /**
     * 一次専門組織表示名
     * @type {string}
     * @memberof EntityAttendeeLabel
     */
    'primary'?: string | null;
    /**
     * 二次専門組織表示名
     * @type {string}
     * @memberof EntityAttendeeLabel
     */
    'secondary'?: string | null;
    /**
     * 隊員表示名
     * @type {string}
     * @memberof EntityAttendeeLabel
     */
    'crew'?: string | null;
}
/**
 * エラーレスポンス
 * @export
 * @interface EntityErrorMsg
 */
export interface EntityErrorMsg {
    /**
     * エラー番号
     * @type {string}
     * @memberof EntityErrorMsg
     */
    'errorNo'?: string;
    /**
     * エラーメッセージ
     * @type {string}
     * @memberof EntityErrorMsg
     */
    'errorMsg'?: string;
}
/**
 * 
 * @export
 * @interface EntityExtraInformationOfMember
 */
export interface EntityExtraInformationOfMember {
    /**
     * sub
     * @type {string}
     * @memberof EntityExtraInformationOfMember
     */
    'sub'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityExtraInformationOfMember
     */
    'email'?: string;
    /**
     * 名称
     * @type {string}
     * @memberof EntityExtraInformationOfMember
     */
    'name'?: string;
    /**
     * 電話番号
     * @type {Array<string>}
     * @memberof EntityExtraInformationOfMember
     */
    'telephones'?: Array<string> | null;
    /**
     * 電話番号/SMS（E.164）
     * @type {string}
     * @memberof EntityExtraInformationOfMember
     */
    'sms'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityExtraInformationOfMember
     */
    'email2'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityExtraInformationOfMember
     */
    'comment'?: any;
}
/**
 * 
 * @export
 * @interface EntityInvitation
 */
export interface EntityInvitation {
    /**
     * 
     * @type {EntityInvitationInvitation}
     * @memberof EntityInvitation
     */
    'invitation'?: EntityInvitationInvitation;
}
/**
 * 
 * @export
 * @interface EntityInvitationInvitation
 */
export interface EntityInvitationInvitation {
    /**
     * 招待状のID:number
     * @type {number}
     * @memberof EntityInvitationInvitation
     */
    'invitationId'?: number;
    /**
     * 招待状のUUID:uuid
     * @type {string}
     * @memberof EntityInvitationInvitation
     */
    'invitationUuid'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityInvitationInvitation
     */
    'inviter'?: number;
    /**
     * 
     * @type {DomEnableFlag}
     * @memberof EntityInvitationInvitation
     */
    'isEnabled'?: DomEnableFlag;
    /**
     * 会議ID:uuid
     * @type {string}
     * @memberof EntityInvitationInvitation
     */
    'meetingId'?: string;
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityInvitationInvitation
     */
    'organizationId'?: number;
    /**
     * 会議室ID:number
     * @type {number}
     * @memberof EntityInvitationInvitation
     */
    'roomId'?: number;
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityInvitationInvitation
     */
    'serviceId'?: number;
}


/**
 * 
 * @export
 * @interface EntityLocation
 */
export interface EntityLocation {
    /**
     * 契約先ID:number
     * @type {number}
     * @memberof EntityLocation
     */
    'locationId'?: number;
    /**
     * GC番号:string
     * @type {string}
     * @memberof EntityLocation
     */
    'gcNo'?: string;
    /**
     * 号機番号:string
     * @type {string}
     * @memberof EntityLocation
     */
    'gouki'?: string;
    /**
     * 電計番号:string
     * @type {string}
     * @memberof EntityLocation
     */
    'denkei'?: string;
    /**
     * 対象先名称
     * @type {string}
     * @memberof EntityLocation
     */
    'name'?: string;
    /**
     * 
     * @type {DomEnableFlag}
     * @memberof EntityLocation
     */
    'isEnabled'?: DomEnableFlag;
}


/**
 * Amazon Chime SDK Meeting
 * @export
 * @interface EntityMeeting
 */
export interface EntityMeeting {
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'MeetingId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'MeetingHostId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'ExternalMeetingId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'MediaRegion'?: string | null;
    /**
     * 
     * @type {EntityMeetingMediaPlacement}
     * @memberof EntityMeeting
     */
    'MediaPlacement'?: EntityMeetingMediaPlacement | null;
    /**
     * 
     * @type {EntityMeetingMeetingFeatures}
     * @memberof EntityMeeting
     */
    'MeetingFeatures'?: EntityMeetingMeetingFeatures | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'PrimaryMeetingId'?: string | null;
    /**
     * 
     * @type {Array<string | null>}
     * @memberof EntityMeeting
     */
    'TenantIds'?: Array<string | null> | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'MeetingArn'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingDetail
 */
export interface EntityMeetingDetail {
    /**
     * 
     * @type {EntityMeetingRoom}
     * @memberof EntityMeetingDetail
     */
    'room'?: EntityMeetingRoom;
    /**
     * 
     * @type {EntityRoomStatus}
     * @memberof EntityMeetingDetail
     */
    'status'?: EntityRoomStatus;
    /**
     * 
     * @type {EntityLocation}
     * @memberof EntityMeetingDetail
     */
    'location'?: EntityLocation;
    /**
     * 
     * @type {Array<EntitySecondaryOrganizationMember>}
     * @memberof EntityMeetingDetail
     */
    'secondaryOrganizationMembers'?: Array<EntitySecondaryOrganizationMember> | null;
    /**
     * 
     * @type {EntityMeeting}
     * @memberof EntityMeetingDetail
     */
    'meeting'?: EntityMeeting;
    /**
     * 
     * @type {EntityAttendee}
     * @memberof EntityMeetingDetail
     */
    'attendee'?: EntityAttendee;
}
/**
 * 
 * @export
 * @interface EntityMeetingDetailForInvitation
 */
export interface EntityMeetingDetailForInvitation {
    /**
     * 
     * @type {EntityMeetingRoom}
     * @memberof EntityMeetingDetailForInvitation
     */
    'room'?: EntityMeetingRoom;
    /**
     * 
     * @type {EntityRoomStatus}
     * @memberof EntityMeetingDetailForInvitation
     */
    'status'?: EntityRoomStatus;
    /**
     * 
     * @type {EntityLocation}
     * @memberof EntityMeetingDetailForInvitation
     */
    'location'?: EntityLocation;
    /**
     * 
     * @type {Array<EntitySecondaryOrganizationMember>}
     * @memberof EntityMeetingDetailForInvitation
     */
    'secondaryOrganizationMembers'?: Array<EntitySecondaryOrganizationMember> | null;
    /**
     * 
     * @type {EntityMeeting}
     * @memberof EntityMeetingDetailForInvitation
     */
    'meeting'?: EntityMeeting;
    /**
     * 
     * @type {EntityAttendee}
     * @memberof EntityMeetingDetailForInvitation
     */
    'attendee'?: EntityAttendee;
    /**
     * 
     * @type {EntityAttendeeLabel}
     * @memberof EntityMeetingDetailForInvitation
     */
    'attendeeLabel'?: EntityAttendeeLabel;
}
/**
 * 
 * @export
 * @interface EntityMeetingMediaPlacement
 */
export interface EntityMeetingMediaPlacement {
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'AudioHostUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'AudioFallbackUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'SignalingUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'TurnControlUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'ScreenDataUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'ScreenViewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'EventIngestionUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingMeetingFeatures
 */
export interface EntityMeetingMeetingFeatures {
    /**
     * 
     * @type {EntityMeetingMeetingFeaturesAudio}
     * @memberof EntityMeetingMeetingFeatures
     */
    'Audio'?: EntityMeetingMeetingFeaturesAudio | null;
    /**
     * 
     * @type {EntityMeetingMeetingFeaturesVideo}
     * @memberof EntityMeetingMeetingFeatures
     */
    'Video'?: EntityMeetingMeetingFeaturesVideo | null;
    /**
     * 
     * @type {EntityMeetingMeetingFeaturesVideo}
     * @memberof EntityMeetingMeetingFeatures
     */
    'Content'?: EntityMeetingMeetingFeaturesVideo | null;
    /**
     * 
     * @type {EntityMeetingMeetingFeaturesAttendee}
     * @memberof EntityMeetingMeetingFeatures
     */
    'Attendee'?: EntityMeetingMeetingFeaturesAttendee | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingMeetingFeaturesAttendee
 */
export interface EntityMeetingMeetingFeaturesAttendee {
    /**
     * 
     * @type {number}
     * @memberof EntityMeetingMeetingFeaturesAttendee
     */
    'MaxCount'?: number | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingMeetingFeaturesAudio
 */
export interface EntityMeetingMeetingFeaturesAudio {
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMeetingFeaturesAudio
     */
    'EchoReduction'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingMeetingFeaturesVideo
 */
export interface EntityMeetingMeetingFeaturesVideo {
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMeetingFeaturesVideo
     */
    'MaxResolution'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingRoom
 */
export interface EntityMeetingRoom {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityMeetingRoom
     */
    'serviceId'?: number;
    /**
     * 会議室ID:number
     * @type {number}
     * @memberof EntityMeetingRoom
     */
    'roomId'?: number;
    /**
     * 会議室名称
     * @type {string}
     * @memberof EntityMeetingRoom
     */
    'name'?: string;
    /**
     * 表示順:number
     * @type {number}
     * @memberof EntityMeetingRoom
     */
    'viewOrder'?: number;
    /**
     * 
     * @type {DomEnableFlag}
     * @memberof EntityMeetingRoom
     */
    'isEnabled'?: DomEnableFlag;
    /**
     * 
     * @type {DomRoomState}
     * @memberof EntityMeetingRoom
     */
    'state'?: DomRoomState;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityMeetingRoom
     */
    'ownerId'?: number;
    /**
     * 主催者の名前
     * @type {string}
     * @memberof EntityMeetingRoom
     */
    'ownerName'?: string | null;
    /**
     * 
     * @type {EntityLocation}
     * @memberof EntityMeetingRoom
     */
    'location'?: EntityLocation;
}


/**
 * 
 * @export
 * @interface EntityMember
 */
export interface EntityMember {
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityMember
     */
    'memberId'?: number;
    /**
     * 
     * @type {EntityExtraInformationOfMember}
     * @memberof EntityMember
     */
    'member'?: EntityExtraInformationOfMember;
    /**
     * 
     * @type {EntityOrganization}
     * @memberof EntityMember
     */
    'organization'?: EntityOrganization;
    /**
     * 
     * @type {Array<EntityService>}
     * @memberof EntityMember
     */
    'services'?: Array<EntityService>;
}
/**
 * 
 * @export
 * @interface EntityOrganization
 */
export interface EntityOrganization {
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityOrganization
     */
    'organizationId'?: number;
    /**
     * 組織名称
     * @type {string}
     * @memberof EntityOrganization
     */
    'name'?: string;
    /**
     * 
     * @type {DomOrganizationType}
     * @memberof EntityOrganization
     */
    'type'?: DomOrganizationType;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityOrganization
     */
    'tel'?: string;
}


/**
 * 
 * @export
 * @interface EntityRoomStatus
 */
export interface EntityRoomStatus {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityRoomStatus
     */
    'serviceId'?: number;
    /**
     * 会議室ID:number
     * @type {number}
     * @memberof EntityRoomStatus
     */
    'roomId'?: number;
    /**
     * 
     * @type {DomRoomState}
     * @memberof EntityRoomStatus
     */
    'state'?: DomRoomState;
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityRoomStatus
     */
    'organizationId'?: number;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityRoomStatus
     */
    'owner'?: number;
    /**
     * 待機開始日時
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'idlingStartAt'?: string | null;
    /**
     * 待ち受け開始日時
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'waitingStartAt'?: string | null;
    /**
     * 隊員入室日時
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'crewCheckinAt'?: string | null;
    /**
     * 会議開始日時
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'meetingStartAt'?: string | null;
    /**
     * 会議終了日時
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'meetingFinishAt'?: string | null;
    /**
     * 会議ID:uuid
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'meetingUuid'?: string;
    /**
     * ChimeID:uuid
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'chimeUuid'?: string;
}


/**
 * 
 * @export
 * @interface EntitySecondaryOrganizationMember
 */
export interface EntitySecondaryOrganizationMember {
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntitySecondaryOrganizationMember
     */
    'memberId'?: number;
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntitySecondaryOrganizationMember
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'name'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'email'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'tel1'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'tel2'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'tel3'?: string;
    /**
     * 電話番号/SMS（E.164）
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'sms'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'email2'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntitySecondaryOrganizationMember
     */
    'comment'?: any;
    /**
     * 
     * @type {EntitySecondaryOrganizationMemberOrganization}
     * @memberof EntitySecondaryOrganizationMember
     */
    'organization'?: EntitySecondaryOrganizationMemberOrganization | null;
}
/**
 * 
 * @export
 * @interface EntitySecondaryOrganizationMemberOrganization
 */
export interface EntitySecondaryOrganizationMemberOrganization {
    /**
     * 
     * @type {string}
     * @memberof EntitySecondaryOrganizationMemberOrganization
     */
    'name'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntitySecondaryOrganizationMemberOrganization
     */
    'comment'?: any;
    /**
     * 住所
     * @type {string}
     * @memberof EntitySecondaryOrganizationMemberOrganization
     */
    'address'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMemberOrganization
     */
    'tel'?: string;
}
/**
 * 
 * @export
 * @interface EntityService
 */
export interface EntityService {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityService
     */
    'serviceId'?: number;
    /**
     * サービス名称
     * @type {string}
     * @memberof EntityService
     */
    'name'?: string;
    /**
     * 表示順:number
     * @type {number}
     * @memberof EntityService
     */
    'viewOrder'?: number;
    /**
     * 
     * @type {DomEnableFlag}
     * @memberof EntityService
     */
    'isEnabled'?: DomEnableFlag;
}


/**
 * 
 * @export
 * @interface ExitRoomRequest
 */
export interface ExitRoomRequest {
    /**
     * 
     * @type {object}
     * @memberof ExitRoomRequest
     */
    'force'?: object;
}
/**
 * 
 * @export
 * @interface GetInvitations200ResponseInner
 */
export interface GetInvitations200ResponseInner {
    /**
     * 招待状のUUID:uuid
     * @type {string}
     * @memberof GetInvitations200ResponseInner
     */
    'invitationUuid'?: string;
    /**
     * サービスID:number
     * @type {number}
     * @memberof GetInvitations200ResponseInner
     */
    'serviceId'?: number;
    /**
     * 対象先名
     * @type {string}
     * @memberof GetInvitations200ResponseInner
     */
    'locationName'?: string;
    /**
     * 会議開始日時
     * @type {string}
     * @memberof GetInvitations200ResponseInner
     */
    'meetingStartAt'?: string | null;
    /**
     * 招待日時
     * @type {string}
     * @memberof GetInvitations200ResponseInner
     */
    'invitedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface GetPhoto200Response
 */
export interface GetPhoto200Response {
    /**
     * S3 Signed URI
     * @type {string}
     * @memberof GetPhoto200Response
     */
    'image'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof GetPhoto200Response
     */
    'expired'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof GetPhoto200Response
     */
    'takenAt'?: string;
}
/**
 * 
 * @export
 * @interface GetPhotos200ResponseInner
 */
export interface GetPhotos200ResponseInner {
    /**
     * 写真ID:uuid
     * @type {string}
     * @memberof GetPhotos200ResponseInner
     */
    'photoId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPhotos200ResponseInner
     */
    'mime'?: string;
    /**
     * S3 Signed URI
     * @type {string}
     * @memberof GetPhotos200ResponseInner
     */
    'thumbnail'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof GetPhotos200ResponseInner
     */
    'expired'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof GetPhotos200ResponseInner
     */
    'takenAt'?: string;
}
/**
 * 
 * @export
 * @interface InviteMeetingRequest
 */
export interface InviteMeetingRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteMeetingRequest
     */
    'method'?: InviteMeetingRequestMethodEnum | null;
}

export const InviteMeetingRequestMethodEnum = {
    Email: 'email',
    Sms: 'sms',
    None: 'none'
} as const;

export type InviteMeetingRequestMethodEnum = typeof InviteMeetingRequestMethodEnum[keyof typeof InviteMeetingRequestMethodEnum];

/**
 * 
 * @export
 * @interface RequestPhotoUrlRequest
 */
export interface RequestPhotoUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoUrlRequest
     */
    'mime'?: string | null;
}
/**
 * 
 * @export
 * @interface RequestTakePhoto200Response
 */
export interface RequestTakePhoto200Response {
    /**
     * 
     * @type {string}
     * @memberof RequestTakePhoto200Response
     */
    'msg'?: string | null;
}
/**
 * 
 * @export
 * @interface StartMeetingRequest
 */
export interface StartMeetingRequest {
    /**
     * 
     * @type {object}
     * @memberof StartMeetingRequest
     */
    'locationId'?: object;
}

/**
 * LocationApi - axios parameter creator
 * @export
 */
export const LocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 指定のGC番号、電計番号にて、サービスに紐づく契約先を検索。
         * @summary 契約先の検索（電計番号）
         * @param {number} serviceId サービスID
         * @param {string} gcNo GC番号
         * @param {string} denkei 電計番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocationByDenkei: async (serviceId: number, gcNo: string, denkei: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('searchLocationByDenkei', 'serviceId', serviceId)
            // verify required parameter 'gcNo' is not null or undefined
            assertParamExists('searchLocationByDenkei', 'gcNo', gcNo)
            // verify required parameter 'denkei' is not null or undefined
            assertParamExists('searchLocationByDenkei', 'denkei', denkei)
            const localVarPath = `/service/{serviceId}/locations/gc-no/{gcNo}/denkei/{denkei}`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)))
                .replace(`{${"gcNo"}}`, encodeURIComponent(String(gcNo)))
                .replace(`{${"denkei"}}`, encodeURIComponent(String(denkei)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定のGC番号、号機番号にて、サービスに紐づく契約先を検索。
         * @summary 契約先の検索（号機番号）
         * @param {number} serviceId サービスID
         * @param {string} gcNo GC番号
         * @param {string} gouki 号機番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocationByGouki: async (serviceId: number, gcNo: string, gouki: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('searchLocationByGouki', 'serviceId', serviceId)
            // verify required parameter 'gcNo' is not null or undefined
            assertParamExists('searchLocationByGouki', 'gcNo', gcNo)
            // verify required parameter 'gouki' is not null or undefined
            assertParamExists('searchLocationByGouki', 'gouki', gouki)
            const localVarPath = `/service/{serviceId}/locations/gc-no/{gcNo}/gouki/{gouki}`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)))
                .replace(`{${"gcNo"}}`, encodeURIComponent(String(gcNo)))
                .replace(`{${"gouki"}}`, encodeURIComponent(String(gouki)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定のGC番号、名称にて、サービスに紐づく契約先を検索。
         * @summary 契約先の検索（名称）
         * @param {number} serviceId サービスID
         * @param {string} gcNo GC番号
         * @param {string} keyword 契約先名称（あいまい検索のためのキーワード）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocationByName: async (serviceId: number, gcNo: string, keyword: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('searchLocationByName', 'serviceId', serviceId)
            // verify required parameter 'gcNo' is not null or undefined
            assertParamExists('searchLocationByName', 'gcNo', gcNo)
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('searchLocationByName', 'keyword', keyword)
            const localVarPath = `/service/{serviceId}/locations/gc-no/{gcNo}/name/{keyword}`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)))
                .replace(`{${"gcNo"}}`, encodeURIComponent(String(gcNo)))
                .replace(`{${"keyword"}}`, encodeURIComponent(String(keyword)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationApi - functional programming interface
 * @export
 */
export const LocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 指定のGC番号、電計番号にて、サービスに紐づく契約先を検索。
         * @summary 契約先の検索（電計番号）
         * @param {number} serviceId サービスID
         * @param {string} gcNo GC番号
         * @param {string} denkei 電計番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLocationByDenkei(serviceId: number, gcNo: string, denkei: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLocationByDenkei(serviceId, gcNo, denkei, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.searchLocationByDenkei']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定のGC番号、号機番号にて、サービスに紐づく契約先を検索。
         * @summary 契約先の検索（号機番号）
         * @param {number} serviceId サービスID
         * @param {string} gcNo GC番号
         * @param {string} gouki 号機番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLocationByGouki(serviceId: number, gcNo: string, gouki: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLocationByGouki(serviceId, gcNo, gouki, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.searchLocationByGouki']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定のGC番号、名称にて、サービスに紐づく契約先を検索。
         * @summary 契約先の検索（名称）
         * @param {number} serviceId サービスID
         * @param {string} gcNo GC番号
         * @param {string} keyword 契約先名称（あいまい検索のためのキーワード）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLocationByName(serviceId: number, gcNo: string, keyword: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLocationByName(serviceId, gcNo, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.searchLocationByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationApi - factory interface
 * @export
 */
export const LocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationApiFp(configuration)
    return {
        /**
         * 指定のGC番号、電計番号にて、サービスに紐づく契約先を検索。
         * @summary 契約先の検索（電計番号）
         * @param {number} serviceId サービスID
         * @param {string} gcNo GC番号
         * @param {string} denkei 電計番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocationByDenkei(serviceId: number, gcNo: string, denkei: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityLocation>> {
            return localVarFp.searchLocationByDenkei(serviceId, gcNo, denkei, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定のGC番号、号機番号にて、サービスに紐づく契約先を検索。
         * @summary 契約先の検索（号機番号）
         * @param {number} serviceId サービスID
         * @param {string} gcNo GC番号
         * @param {string} gouki 号機番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocationByGouki(serviceId: number, gcNo: string, gouki: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityLocation>> {
            return localVarFp.searchLocationByGouki(serviceId, gcNo, gouki, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定のGC番号、名称にて、サービスに紐づく契約先を検索。
         * @summary 契約先の検索（名称）
         * @param {number} serviceId サービスID
         * @param {string} gcNo GC番号
         * @param {string} keyword 契約先名称（あいまい検索のためのキーワード）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocationByName(serviceId: number, gcNo: string, keyword: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityLocation>> {
            return localVarFp.searchLocationByName(serviceId, gcNo, keyword, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
export class LocationApi extends BaseAPI {
    /**
     * 指定のGC番号、電計番号にて、サービスに紐づく契約先を検索。
     * @summary 契約先の検索（電計番号）
     * @param {number} serviceId サービスID
     * @param {string} gcNo GC番号
     * @param {string} denkei 電計番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public searchLocationByDenkei(serviceId: number, gcNo: string, denkei: string, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).searchLocationByDenkei(serviceId, gcNo, denkei, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定のGC番号、号機番号にて、サービスに紐づく契約先を検索。
     * @summary 契約先の検索（号機番号）
     * @param {number} serviceId サービスID
     * @param {string} gcNo GC番号
     * @param {string} gouki 号機番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public searchLocationByGouki(serviceId: number, gcNo: string, gouki: string, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).searchLocationByGouki(serviceId, gcNo, gouki, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定のGC番号、名称にて、サービスに紐づく契約先を検索。
     * @summary 契約先の検索（名称）
     * @param {number} serviceId サービスID
     * @param {string} gcNo GC番号
     * @param {string} keyword 契約先名称（あいまい検索のためのキーワード）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public searchLocationByName(serviceId: number, gcNo: string, keyword: string, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).searchLocationByName(serviceId, gcNo, keyword, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeetingApi - axios parameter creator
 * @export
 */
export const MeetingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 招待状からの参加
         * @param {string} invitationUuid 招待状のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation: async (invitationUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationUuid' is not null or undefined
            assertParamExists('acceptInvitation', 'invitationUuid', invitationUuid)
            const localVarPath = `/invitation/{invitationUuid}`
                .replace(`{${"invitationUuid"}}`, encodeURIComponent(String(invitationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 会議（案件対応）をキャンセルする。（待受->待機）
         * @param {number} roomId 会議室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMeeting: async (roomId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('cancelMeeting', 'roomId', roomId)
            const localVarPath = `/meeting-room/{roomId}/meeting`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 会議・RTCの終了
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endMeeting: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('endMeeting', 'meetingId', meetingId)
            const localVarPath = `/meeting/{meetingId}/end`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 会議情報の取得
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingDetail: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingDetail', 'meetingId', meetingId)
            const localVarPath = `/meeting/{meetingId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 招待状の発行
         * @param {string} meetingId 会議ID
         * @param {number} inviterId 招待者のユーザID
         * @param {InviteMeetingRequest} [inviteMeetingRequest] 招待状の送信方法
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteMeeting: async (meetingId: string, inviterId: number, inviteMeetingRequest?: InviteMeetingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('inviteMeeting', 'meetingId', meetingId)
            // verify required parameter 'inviterId' is not null or undefined
            assertParamExists('inviteMeeting', 'inviterId', inviterId)
            const localVarPath = `/meeting/{meetingId}/invite/{inviterId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"inviterId"}}`, encodeURIComponent(String(inviterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteMeetingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 会議・RTCの開始/参加
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinMeeting: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('joinMeeting', 'meetingId', meetingId)
            const localVarPath = `/meeting/{meetingId}/join`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 会議・RTCの離席
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveMeeting: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('leaveMeeting', 'meetingId', meetingId)
            const localVarPath = `/meeting/{meetingId}/leave`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 招待状で参加した会議の離席
         * @param {string} invitationUuid 招待状のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveMeetingSecondary: async (invitationUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationUuid' is not null or undefined
            assertParamExists('leaveMeetingSecondary', 'invitationUuid', invitationUuid)
            const localVarPath = `/invitation/{invitationUuid}/leave`
                .replace(`{${"invitationUuid"}}`, encodeURIComponent(String(invitationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 会議・RTCの準備、ID発行
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareMeeting: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('prepareMeeting', 'meetingId', meetingId)
            const localVarPath = `/meeting/{meetingId}/prepare`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会議（案件対応）を開始する。
         * @summary 会議新規開始(一次専門組織/非RTC)
         * @param {number} roomId 会議室ID
         * @param {StartMeetingRequest} startMeetingRequest 対象先を指定。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMeeting: async (roomId: number, startMeetingRequest: StartMeetingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('startMeeting', 'roomId', roomId)
            // verify required parameter 'startMeetingRequest' is not null or undefined
            assertParamExists('startMeeting', 'startMeetingRequest', startMeetingRequest)
            const localVarPath = `/meeting-room/{roomId}/meeting`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startMeetingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingApi - functional programming interface
 * @export
 */
export const MeetingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 招待状からの参加
         * @param {string} invitationUuid 招待状のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInvitation(invitationUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetailForInvitation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInvitation(invitationUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingApi.acceptInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 会議（案件対応）をキャンセルする。（待受->待機）
         * @param {number} roomId 会議室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelMeeting(roomId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelMeeting(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingApi.cancelMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 会議・RTCの終了
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endMeeting(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endMeeting(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingApi.endMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 会議情報の取得
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingDetail(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingDetail(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingApi.getMeetingDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 招待状の発行
         * @param {string} meetingId 会議ID
         * @param {number} inviterId 招待者のユーザID
         * @param {InviteMeetingRequest} [inviteMeetingRequest] 招待状の送信方法
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteMeeting(meetingId: string, inviterId: number, inviteMeetingRequest?: InviteMeetingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityInvitation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteMeeting(meetingId, inviterId, inviteMeetingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingApi.inviteMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 会議・RTCの開始/参加
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinMeeting(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinMeeting(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingApi.joinMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 会議・RTCの離席
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveMeeting(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveMeeting(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingApi.leaveMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 招待状で参加した会議の離席
         * @param {string} invitationUuid 招待状のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveMeetingSecondary(invitationUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveMeetingSecondary(invitationUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingApi.leaveMeetingSecondary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 会議・RTCの準備、ID発行
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepareMeeting(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prepareMeeting(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingApi.prepareMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 会議（案件対応）を開始する。
         * @summary 会議新規開始(一次専門組織/非RTC)
         * @param {number} roomId 会議室ID
         * @param {StartMeetingRequest} startMeetingRequest 対象先を指定。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startMeeting(roomId: number, startMeetingRequest: StartMeetingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startMeeting(roomId, startMeetingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingApi.startMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingApi - factory interface
 * @export
 */
export const MeetingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingApiFp(configuration)
    return {
        /**
         * 
         * @summary 招待状からの参加
         * @param {string} invitationUuid 招待状のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation(invitationUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetailForInvitation> {
            return localVarFp.acceptInvitation(invitationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 会議（案件対応）をキャンセルする。（待受->待機）
         * @param {number} roomId 会議室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMeeting(roomId: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.cancelMeeting(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 会議・RTCの終了
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endMeeting(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.endMeeting(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 会議情報の取得
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingDetail(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.getMeetingDetail(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 招待状の発行
         * @param {string} meetingId 会議ID
         * @param {number} inviterId 招待者のユーザID
         * @param {InviteMeetingRequest} [inviteMeetingRequest] 招待状の送信方法
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteMeeting(meetingId: string, inviterId: number, inviteMeetingRequest?: InviteMeetingRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityInvitation> {
            return localVarFp.inviteMeeting(meetingId, inviterId, inviteMeetingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 会議・RTCの開始/参加
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinMeeting(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.joinMeeting(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 会議・RTCの離席
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveMeeting(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.leaveMeeting(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 招待状で参加した会議の離席
         * @param {string} invitationUuid 招待状のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveMeetingSecondary(invitationUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.leaveMeetingSecondary(invitationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 会議・RTCの準備、ID発行
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareMeeting(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.prepareMeeting(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 会議（案件対応）を開始する。
         * @summary 会議新規開始(一次専門組織/非RTC)
         * @param {number} roomId 会議室ID
         * @param {StartMeetingRequest} startMeetingRequest 対象先を指定。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMeeting(roomId: number, startMeetingRequest: StartMeetingRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.startMeeting(roomId, startMeetingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingApi - object-oriented interface
 * @export
 * @class MeetingApi
 * @extends {BaseAPI}
 */
export class MeetingApi extends BaseAPI {
    /**
     * 
     * @summary 招待状からの参加
     * @param {string} invitationUuid 招待状のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingApi
     */
    public acceptInvitation(invitationUuid: string, options?: RawAxiosRequestConfig) {
        return MeetingApiFp(this.configuration).acceptInvitation(invitationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 会議（案件対応）をキャンセルする。（待受->待機）
     * @param {number} roomId 会議室ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingApi
     */
    public cancelMeeting(roomId: number, options?: RawAxiosRequestConfig) {
        return MeetingApiFp(this.configuration).cancelMeeting(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 会議・RTCの終了
     * @param {string} meetingId 会議ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingApi
     */
    public endMeeting(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingApiFp(this.configuration).endMeeting(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 会議情報の取得
     * @param {string} meetingId 会議ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingApi
     */
    public getMeetingDetail(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingApiFp(this.configuration).getMeetingDetail(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 招待状の発行
     * @param {string} meetingId 会議ID
     * @param {number} inviterId 招待者のユーザID
     * @param {InviteMeetingRequest} [inviteMeetingRequest] 招待状の送信方法
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingApi
     */
    public inviteMeeting(meetingId: string, inviterId: number, inviteMeetingRequest?: InviteMeetingRequest, options?: RawAxiosRequestConfig) {
        return MeetingApiFp(this.configuration).inviteMeeting(meetingId, inviterId, inviteMeetingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 会議・RTCの開始/参加
     * @param {string} meetingId 会議ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingApi
     */
    public joinMeeting(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingApiFp(this.configuration).joinMeeting(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 会議・RTCの離席
     * @param {string} meetingId 会議ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingApi
     */
    public leaveMeeting(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingApiFp(this.configuration).leaveMeeting(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 招待状で参加した会議の離席
     * @param {string} invitationUuid 招待状のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingApi
     */
    public leaveMeetingSecondary(invitationUuid: string, options?: RawAxiosRequestConfig) {
        return MeetingApiFp(this.configuration).leaveMeetingSecondary(invitationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 会議・RTCの準備、ID発行
     * @param {string} meetingId 会議ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingApi
     */
    public prepareMeeting(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingApiFp(this.configuration).prepareMeeting(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会議（案件対応）を開始する。
     * @summary 会議新規開始(一次専門組織/非RTC)
     * @param {number} roomId 会議室ID
     * @param {StartMeetingRequest} startMeetingRequest 対象先を指定。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingApi
     */
    public startMeeting(roomId: number, startMeetingRequest: StartMeetingRequest, options?: RawAxiosRequestConfig) {
        return MeetingApiFp(this.configuration).startMeeting(roomId, startMeetingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeetingPhotoApi - axios parameter creator
 * @export
 */
export const MeetingPhotoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 画像登録失敗
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failTakePhoto: async (meetingId: string, photoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('failTakePhoto', 'meetingId', meetingId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('failTakePhoto', 'photoId', photoId)
            const localVarPath = `/meeting/{meetingId}/photo/{photoId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 画像取得
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto: async (meetingId: string, photoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getPhoto', 'meetingId', meetingId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('getPhoto', 'photoId', photoId)
            const localVarPath = `/meeting/{meetingId}/photo/{photoId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 画像一覧取得
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotos: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getPhotos', 'meetingId', meetingId)
            const localVarPath = `/meeting/{meetingId}/photos`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 画像登録用URL発行
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {RequestPhotoUrlRequest} [requestPhotoUrlRequest] ファイルタイプ（MIME）。指定なしの時は”image/jpeg\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPhotoUrl: async (meetingId: string, photoId: string, requestPhotoUrlRequest?: RequestPhotoUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('requestPhotoUrl', 'meetingId', meetingId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('requestPhotoUrl', 'photoId', photoId)
            const localVarPath = `/meeting/{meetingId}/photo/{photoId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPhotoUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 画像共有終了要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestShareFinish: async (meetingId: string, photoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('requestShareFinish', 'meetingId', meetingId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('requestShareFinish', 'photoId', photoId)
            const localVarPath = `/meeting/{meetingId}/photo/{photoId}/share`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 画像共有要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestShareStart: async (meetingId: string, photoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('requestShareStart', 'meetingId', meetingId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('requestShareStart', 'photoId', photoId)
            const localVarPath = `/meeting/{meetingId}/photo/{photoId}/share`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 写真撮影要求
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTakePhoto: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('requestTakePhoto', 'meetingId', meetingId)
            const localVarPath = `/meeting/{meetingId}/photo`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingPhotoApi - functional programming interface
 * @export
 */
export const MeetingPhotoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingPhotoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 画像登録失敗
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async failTakePhoto(meetingId: string, photoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestTakePhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.failTakePhoto(meetingId, photoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.failTakePhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 画像取得
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhoto(meetingId: string, photoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhoto(meetingId, photoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.getPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 画像一覧取得
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhotos(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPhotos200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhotos(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.getPhotos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 画像登録用URL発行
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {RequestPhotoUrlRequest} [requestPhotoUrlRequest] ファイルタイプ（MIME）。指定なしの時は”image/jpeg\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPhotoUrl(meetingId: string, photoId: string, requestPhotoUrlRequest?: RequestPhotoUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPhotoUrl(meetingId, photoId, requestPhotoUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.requestPhotoUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 画像共有終了要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestShareFinish(meetingId: string, photoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestTakePhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestShareFinish(meetingId, photoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.requestShareFinish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 画像共有要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestShareStart(meetingId: string, photoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestTakePhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestShareStart(meetingId, photoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.requestShareStart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 写真撮影要求
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestTakePhoto(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestTakePhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestTakePhoto(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.requestTakePhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingPhotoApi - factory interface
 * @export
 */
export const MeetingPhotoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingPhotoApiFp(configuration)
    return {
        /**
         * 
         * @summary 画像登録失敗
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failTakePhoto(meetingId: string, photoId: string, options?: RawAxiosRequestConfig): AxiosPromise<RequestTakePhoto200Response> {
            return localVarFp.failTakePhoto(meetingId, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 画像取得
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto(meetingId: string, photoId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPhoto200Response> {
            return localVarFp.getPhoto(meetingId, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 画像一覧取得
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotos(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetPhotos200ResponseInner>> {
            return localVarFp.getPhotos(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 画像登録用URL発行
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {RequestPhotoUrlRequest} [requestPhotoUrlRequest] ファイルタイプ（MIME）。指定なしの時は”image/jpeg\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPhotoUrl(meetingId: string, photoId: string, requestPhotoUrlRequest?: RequestPhotoUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPhoto200Response> {
            return localVarFp.requestPhotoUrl(meetingId, photoId, requestPhotoUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 画像共有終了要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestShareFinish(meetingId: string, photoId: string, options?: RawAxiosRequestConfig): AxiosPromise<RequestTakePhoto200Response> {
            return localVarFp.requestShareFinish(meetingId, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 画像共有要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestShareStart(meetingId: string, photoId: string, options?: RawAxiosRequestConfig): AxiosPromise<RequestTakePhoto200Response> {
            return localVarFp.requestShareStart(meetingId, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 写真撮影要求
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTakePhoto(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<RequestTakePhoto200Response> {
            return localVarFp.requestTakePhoto(meetingId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingPhotoApi - object-oriented interface
 * @export
 * @class MeetingPhotoApi
 * @extends {BaseAPI}
 */
export class MeetingPhotoApi extends BaseAPI {
    /**
     * 
     * @summary 画像登録失敗
     * @param {string} meetingId 会議ID
     * @param {string} photoId 写真ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public failTakePhoto(meetingId: string, photoId: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).failTakePhoto(meetingId, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 画像取得
     * @param {string} meetingId 会議ID
     * @param {string} photoId 写真ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public getPhoto(meetingId: string, photoId: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).getPhoto(meetingId, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 画像一覧取得
     * @param {string} meetingId 会議ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public getPhotos(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).getPhotos(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 画像登録用URL発行
     * @param {string} meetingId 会議ID
     * @param {string} photoId 写真ID
     * @param {RequestPhotoUrlRequest} [requestPhotoUrlRequest] ファイルタイプ（MIME）。指定なしの時は”image/jpeg\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public requestPhotoUrl(meetingId: string, photoId: string, requestPhotoUrlRequest?: RequestPhotoUrlRequest, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).requestPhotoUrl(meetingId, photoId, requestPhotoUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 画像共有終了要求
     * @param {string} meetingId 会議ID
     * @param {string} photoId 写真ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public requestShareFinish(meetingId: string, photoId: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).requestShareFinish(meetingId, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 画像共有要求
     * @param {string} meetingId 会議ID
     * @param {string} photoId 写真ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public requestShareStart(meetingId: string, photoId: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).requestShareStart(meetingId, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 写真撮影要求
     * @param {string} meetingId 会議ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public requestTakePhoto(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).requestTakePhoto(meetingId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MemberApi - axios parameter creator
 * @export
 */
export const MemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 二次専門組織、インビテーション一覧の取得
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitations: async (memberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getInvitations', 'memberId', memberId)
            const localVarPath = `/members/me/invitations`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * cognito認証後、ログイン履歴の保持等、AP側ログイン処理。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログイン処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/members/me/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * cognitoサインアウト前、履歴の保持等。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログアウト処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/members/me/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MemberApi - functional programming interface
 * @export
 */
export const MemberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MemberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 二次専門組織、インビテーション一覧の取得
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitations(memberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetInvitations200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitations(memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberApi.getInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * cognito認証後、ログイン履歴の保持等、AP側ログイン処理。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログイン処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * cognitoサインアウト前、履歴の保持等。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログアウト処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MemberApi - factory interface
 * @export
 */
export const MemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MemberApiFp(configuration)
    return {
        /**
         * 
         * @summary 二次専門組織、インビテーション一覧の取得
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitations(memberId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetInvitations200ResponseInner>> {
            return localVarFp.getInvitations(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * cognito認証後、ログイン履歴の保持等、AP側ログイン処理。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログイン処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(options?: RawAxiosRequestConfig): AxiosPromise<EntityMember> {
            return localVarFp.login(options).then((request) => request(axios, basePath));
        },
        /**
         * cognitoサインアウト前、履歴の保持等。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログアウト処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MemberApi - object-oriented interface
 * @export
 * @class MemberApi
 * @extends {BaseAPI}
 */
export class MemberApi extends BaseAPI {
    /**
     * 
     * @summary 二次専門組織、インビテーション一覧の取得
     * @param {number} memberId ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public getInvitations(memberId: number, options?: RawAxiosRequestConfig) {
        return MemberApiFp(this.configuration).getInvitations(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * cognito認証後、ログイン履歴の保持等、AP側ログイン処理。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
     * @summary ログイン処理
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public login(options?: RawAxiosRequestConfig) {
        return MemberApiFp(this.configuration).login(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * cognitoサインアウト前、履歴の保持等。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
     * @summary ログアウト処理
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return MemberApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RoomApi - axios parameter creator
 * @export
 */
export const RoomApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 指定の会議室に入室する（オーナー）
         * @summary 会議室入室
         * @param {number} roomId 会議室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterRoom: async (roomId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('enterRoom', 'roomId', roomId)
            const localVarPath = `/meeting-room/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の会議室から退室する（オーナー）。強制フラグがtrueの際は、自身の会議室でない場合も退室できる（同一サービスにパーミッションを持ってるユーザ）
         * @summary 会議室退室
         * @param {number} roomId 会議室ID
         * @param {ExitRoomRequest} [exitRoomRequest] 強制フラグ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exitRoom: async (roomId: number, exitRoomRequest?: ExitRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('exitRoom', 'roomId', roomId)
            const localVarPath = `/meeting-room/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exitRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の会議室の詳細情報を取得する
         * @summary 会議室詳細/開催中会議情報取得
         * @param {number} roomId 会議室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomDetail: async (roomId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getRoomDetail', 'roomId', roomId)
            const localVarPath = `/meeting-room/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 該当のサービスに割り当てられた会議室の一覧を取得する
         * @summary 会議室一覧取得
         * @param {number} serviceId サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRooms: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getRooms', 'serviceId', serviceId)
            const localVarPath = `/service/{serviceId}/meeting-rooms`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoomApi - functional programming interface
 * @export
 */
export const RoomApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoomApiAxiosParamCreator(configuration)
    return {
        /**
         * 指定の会議室に入室する（オーナー）
         * @summary 会議室入室
         * @param {number} roomId 会議室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterRoom(roomId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterRoom(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomApi.enterRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の会議室から退室する（オーナー）。強制フラグがtrueの際は、自身の会議室でない場合も退室できる（同一サービスにパーミッションを持ってるユーザ）
         * @summary 会議室退室
         * @param {number} roomId 会議室ID
         * @param {ExitRoomRequest} [exitRoomRequest] 強制フラグ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exitRoom(roomId: number, exitRoomRequest?: ExitRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exitRoom(roomId, exitRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomApi.exitRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の会議室の詳細情報を取得する
         * @summary 会議室詳細/開催中会議情報取得
         * @param {number} roomId 会議室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomDetail(roomId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomDetail(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomApi.getRoomDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 該当のサービスに割り当てられた会議室の一覧を取得する
         * @summary 会議室一覧取得
         * @param {number} serviceId サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRooms(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityMeetingRoom>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRooms(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomApi.getRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RoomApi - factory interface
 * @export
 */
export const RoomApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoomApiFp(configuration)
    return {
        /**
         * 指定の会議室に入室する（オーナー）
         * @summary 会議室入室
         * @param {number} roomId 会議室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterRoom(roomId: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.enterRoom(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の会議室から退室する（オーナー）。強制フラグがtrueの際は、自身の会議室でない場合も退室できる（同一サービスにパーミッションを持ってるユーザ）
         * @summary 会議室退室
         * @param {number} roomId 会議室ID
         * @param {ExitRoomRequest} [exitRoomRequest] 強制フラグ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exitRoom(roomId: number, exitRoomRequest?: ExitRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.exitRoom(roomId, exitRoomRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の会議室の詳細情報を取得する
         * @summary 会議室詳細/開催中会議情報取得
         * @param {number} roomId 会議室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomDetail(roomId: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.getRoomDetail(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 該当のサービスに割り当てられた会議室の一覧を取得する
         * @summary 会議室一覧取得
         * @param {number} serviceId サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRooms(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityMeetingRoom>> {
            return localVarFp.getRooms(serviceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoomApi - object-oriented interface
 * @export
 * @class RoomApi
 * @extends {BaseAPI}
 */
export class RoomApi extends BaseAPI {
    /**
     * 指定の会議室に入室する（オーナー）
     * @summary 会議室入室
     * @param {number} roomId 会議室ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public enterRoom(roomId: number, options?: RawAxiosRequestConfig) {
        return RoomApiFp(this.configuration).enterRoom(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の会議室から退室する（オーナー）。強制フラグがtrueの際は、自身の会議室でない場合も退室できる（同一サービスにパーミッションを持ってるユーザ）
     * @summary 会議室退室
     * @param {number} roomId 会議室ID
     * @param {ExitRoomRequest} [exitRoomRequest] 強制フラグ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public exitRoom(roomId: number, exitRoomRequest?: ExitRoomRequest, options?: RawAxiosRequestConfig) {
        return RoomApiFp(this.configuration).exitRoom(roomId, exitRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の会議室の詳細情報を取得する
     * @summary 会議室詳細/開催中会議情報取得
     * @param {number} roomId 会議室ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public getRoomDetail(roomId: number, options?: RawAxiosRequestConfig) {
        return RoomApiFp(this.configuration).getRoomDetail(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 該当のサービスに割り当てられた会議室の一覧を取得する
     * @summary 会議室一覧取得
     * @param {number} serviceId サービスID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public getRooms(serviceId: number, options?: RawAxiosRequestConfig) {
        return RoomApiFp(this.configuration).getRooms(serviceId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceApi - axios parameter creator
 * @export
 */
export const ServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 現在有効なサービスの一覧を取得する
         * @summary サービス一覧取得
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getService: async (xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceApi - functional programming interface
 * @export
 */
export const ServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 現在有効なサービスの一覧を取得する
         * @summary サービス一覧取得
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getService(xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityService>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getService(xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceApi.getService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceApi - factory interface
 * @export
 */
export const ServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceApiFp(configuration)
    return {
        /**
         * 現在有効なサービスの一覧を取得する
         * @summary サービス一覧取得
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getService(xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityService>> {
            return localVarFp.getService(xCREWID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
export class ServiceApi extends BaseAPI {
    /**
     * 現在有効なサービスの一覧を取得する
     * @summary サービス一覧取得
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getService(xCREWID?: string, options?: RawAxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getService(xCREWID, options).then((request) => request(this.axios, this.basePath));
    }
}



